export {
  AdminRouteMap,
  ChallengeRouteMap,
  ExerciseRouteMap,
  InitialRouteMap,
  PatientRouteMap,
  ResourceRouteMap,
  UsersRouteMap,
} from './base';
export { converToDayjs, formatToString, renderAge } from './dayjs';
export {
  ACCOUNT_TYPE,
  AccountTypeLookUp,
  DaysOfWeekOptions,
  DayOfWeekIndex,
  DATERANGE,
  GOALTYPECONSTANTS,
  LIBRARYITEMTYPE,
  NOTERATING,
  ALERT_TYPE,
  alertPriority,
  RegimenOptions,
  THEMEMODE,
  TargetSideOptions,
  TherapyTypeValue,
  TherapistSpecializationOptions,
  TherapistSpecToType,
  TherapyTypeOptions,
  US_STATES,
} from './derived';

export const AdminToken = 'admin-token';
export const XSRF_TOKEN = 'XSRF-TOKEN';

export type DateRangeType = 'week' | 'month' | 'year' | 'notes';
export type RegimenType = 'HABIT' | 'REPETITION' | 'FATIGUE' | '';
export type ThemeModeType = 'light' | 'dark';
